import { buildIndexSpaceSlab, getDepthRun, getSlabAxisBound, } from './indexSpaceSlab.js';
import { signedDistanceToPlane } from './slabMembership.js';
export function* iterateVoxelsInShape(options) {
    const { volume, planePoint, viewPlaneNormal: normal, referencePlaneThickness, depthCoverage, getShapeRuns, isInShape, columnAxis: forcedColumnAxis, } = options;
    const { dimensions, direction, spacing, origin } = volume;
    const slab = buildIndexSpaceSlab(volume, planePoint, normal, referencePlaneThickness, { columnAxis: forcedColumnAxis, depthCoverage });
    const { outerAxis, rowAxis, columnAxis } = slab;
    const volumeBounds = [0, 1, 2].map((axis) => [
        0,
        dimensions[axis] - 1,
    ]);
    const requestedBounds = options.bounds;
    const bounds = requestedBounds
        ? [0, 1, 2].map((axis) => [
            Math.max(requestedBounds[axis][0], volumeBounds[axis][0]),
            Math.min(requestedBounds[axis][1], volumeBounds[axis][1]),
        ])
        : volumeBounds;
    if (bounds.some(([min, max]) => min > max)) {
        return;
    }
    const axisStep = [0, 1, 2].map((axis) => {
        const unit = direction.slice(axis * 3, axis * 3 + 3);
        return [
            unit[0] * spacing[axis],
            unit[1] * spacing[axis],
            unit[2] * spacing[axis],
        ];
    });
    const outerRange = getSlabAxisBound(slab, outerAxis, bounds);
    if (!outerRange) {
        return;
    }
    const ijk = [0, 0, 0];
    const center = [0, 0, 0];
    const visit = { ijk, center, depth: 0 };
    const columnStep = axisStep[columnAxis];
    for (let outer = outerRange[0]; outer <= outerRange[1]; outer++) {
        const rowRange = getSlabAxisBound(slab, rowAxis, bounds, {
            axis: outerAxis,
            index: outer,
        });
        if (!rowRange) {
            continue;
        }
        const outerStep = axisStep[outerAxis];
        const rowStep = axisStep[rowAxis];
        for (let row = rowRange[0]; row <= rowRange[1]; row++) {
            const depthRun = getDepthRun(slab, outer, row, bounds[columnAxis]);
            if (!depthRun) {
                continue;
            }
            const shapeRuns = getShapeRuns
                ? getShapeRuns(outer, row, depthRun, slab)
                : [depthRun];
            ijk[outerAxis] = outer;
            ijk[rowAxis] = row;
            for (const shapeRun of shapeRuns) {
                const runMin = Math.max(shapeRun[0], depthRun[0]);
                const runMax = Math.min(shapeRun[1], depthRun[1]);
                if (runMin > runMax) {
                    continue;
                }
                for (let axis = 0; axis < 3; axis++) {
                    center[axis] =
                        origin[axis] +
                            outer * outerStep[axis] +
                            row * rowStep[axis] +
                            runMin * columnStep[axis];
                }
                for (let column = runMin; column <= runMax; column++) {
                    ijk[columnAxis] = column;
                    if (!isInShape || isInShape(center, ijk)) {
                        visit.depth = signedDistanceToPlane(center, planePoint, normal);
                        yield visit;
                    }
                    center[0] += columnStep[0];
                    center[1] += columnStep[1];
                    center[2] += columnStep[2];
                }
            }
        }
    }
}
export function collectVoxelsInShape(options) {
    const collected = [];
    for (const { ijk } of iterateVoxelsInShape(options)) {
        collected.push([ijk[0], ijk[1], ijk[2]]);
    }
    return collected;
}
